import React, { useEffect } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateWrapperInfo } from "../../../../../services/menuApp/menuService";
import { ERROR_MESSAGE_UNEXPECTED_ERROR, SUCCESSFULLY_UPDATED } from "../../../../../utils/consts";
import ButtonCommon from "../../../../../components/buttons/ButtonCommon";
import TextfieldDefaultNew from "../../../../../components/textField/TextfieldDefaultNew";
import ColorSelection from "../../../../PrestoExpressEatprestoApp/pages/ThemeCustomizationPage/ColorSelection";
import DialogCommonDefault from "../../../../../components/dialogs/DialogCommonDefault";
import { updateDirectoryInStore } from "../../../../../redux/actions/menu";



export interface DirectoryEditModalProps {
  isOpen: any;
  setIsOpen: any;
  setDirectoryName: any;
  directoryName: any;
  isDirectoryNameEmpty: any;
  setIsDepartmentEmpty: any;
  handleCloseDirectoryEditModal: any;
  setUrl: any;
  isLoadingButton: any;
  url: any;
  setIsLoadingButton: any;
  categoryId: any;
  directoryId: any;
  directoryLevel: any;
  setSuccess: any;
  setError: any;
  setIsDirectoryNameEmpty: any;
  menuNodeList: any;
  wrapperId: any;
  menuId: any;
  firstWrapperId: any;
  setMenuNodeList: any;
  isRoot: any;
  setIsOpenDirectoryOrProductSelectionModal: any;
  selectedWrapper: any;
  setColor: any;
  color: any;
  onDirectoryUpdated?: (updatedDirectory: any) => void;
  setCurrentContent?: any;
  setCurrentDirectoryStack?: any;
  currentDirectoryStack?: any;
  isEditDisabled?: any
} 

const DirectoryEditModal: React.FunctionComponent<DirectoryEditModalProps> = ({
  isOpen,
  setIsOpen,
  setDirectoryName,
  directoryName,
  isDirectoryNameEmpty,
  setIsDepartmentEmpty,
  handleCloseDirectoryEditModal,
  setUrl,
  isLoadingButton,
  url,
  setIsLoadingButton,
  categoryId,
  directoryId,
  directoryLevel,
  setSuccess,
  setError,
  setIsDirectoryNameEmpty,
  menuNodeList,
  wrapperId,
  menuId,
  firstWrapperId,
  setMenuNodeList,
  isRoot,
  setIsOpenDirectoryOrProductSelectionModal,
  selectedWrapper,
  setColor,
  color,
  onDirectoryUpdated,
  setCurrentContent,
  setCurrentDirectoryStack,
  currentDirectoryStack,
  isEditDisabled=false
}) => {
  const match: any = useRouteMatch();
  const dispatch = useDispatch();
  const [directoryNameInitial, setDirectoryNameInitial] = React.useState("");
  const [urlInitial, setUrlInitial] = React.useState("");
  const [colorInitial, setColorInitial] = React.useState("");

  const handleDisable = () => {
    if(isEditDisabled) return true
    if (
      _.isEqual(url, urlInitial) &&
      color === colorInitial &&
      directoryName === directoryNameInitial
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleDirectoryEditInfo = async () => {
    setIsLoadingButton(true);
    if (directoryName) {
      const body = {
        id: selectedWrapper.id,
        name: directoryName,
        locationId: match.params.locationId,
        categoryId: selectedWrapper.categoryId,
        nameShort: selectedWrapper.nameShort || "",
        img: url,
        colour: color,
        version: selectedWrapper.version,
      };
      try {
        let summary = [];
        if (selectedWrapper?.name !== directoryName) {
          summary.push(
            `Directory name changed from ${selectedWrapper?.name} to ${directoryName}`,
          );
        }
        if (selectedWrapper?.colour !== color) {
          summary.push(
            `Color changed from ${selectedWrapper?.colour} to ${color}`,
          );
        }
        if (selectedWrapper?.img !== url) {
          summary.push(`Image changed from ${selectedWrapper?.img} to ${url}`);
        }

        const summaryString = summary.join("\\n");

        const res = await updateWrapperInfo(
          match.params.locationId,
          body,
          "Menus Changed",
          summaryString,
          "menu",
        );

        if (res.data.status === 409) {
          setError("Version conflict. Please try again.");
          setIsLoadingButton(false);
          return;
        } else {
          const updatedItem = res.data.data;
          const updatedData = Array.isArray(updatedItem)
            ? updatedItem[0]
            : updatedItem;

          console.log("Updated data from API:", updatedData);

          // Update Redux store directly with the response data
          const updatedDataForRedux = {
            id: updatedData.id,
            valid: updatedData.valid,
            version: updatedData.version,
            name: updatedData.name,
            colour: updatedData.colour,
            img: updatedData.img,
            desc: updatedData.desc,
            directory: updatedData.directory,
            directoryId: updatedData.directoryId,
            directoryLevel: updatedData.directoryLevel,
            itemType: updatedData.itemType,
            allYouCanEat: updatedData.allYouCanEat,
            kiosk: updatedData.kiosk,
            cover: updatedData.cover,
            nameShort: updatedData.nameShort,
            viewOrder: updatedData.viewOrder,
          };

          dispatch(updateDirectoryInStore(updatedDataForRedux));

          if (onDirectoryUpdated) {
            onDirectoryUpdated(updatedData);
          }

          setIsDirectoryNameEmpty(false);
          setIsLoadingButton(false);
          setIsOpen(false);
          setIsOpenDirectoryOrProductSelectionModal(false);
          setSuccess(SUCCESSFULLY_UPDATED);
        }
      } catch (error) {
        console.log("Error editing directory:", error);
        setIsLoadingButton(false);
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      }
    } else {
      setIsLoadingButton(false);
      setIsDirectoryNameEmpty(true);
    }
  };

  useEffect(() => {
    if (
      isOpen &&
      selectedWrapper &&
      Object.values(selectedWrapper).length > 0
    ) {
      const { name, img, colour } = selectedWrapper;
      setDirectoryName(name || "");
      setDirectoryNameInitial(name || "");
      setUrl(img || "");
      setUrlInitial(img || "");
      setColor(colour || "");
      setColorInitial(colour || "");
    }
  }, [selectedWrapper, isOpen, setDirectoryName, setUrl, setColor]);

  return (
    <DialogCommonDefault
      open={isOpen}
      setOpen={setIsOpen}
      isNeedFixedHeight={false}
    >
      <DialogTitle>Edit Directory</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ paddingLeft: "4px" }}>
              Directory Name
            </Typography>
            <TextfieldDefaultNew
              id="sign-password-input"
              name="sign-password-input"
              onChange={(e: any) => {
                setIsDepartmentEmpty(false);
                setDirectoryName(e.target.value);
              }}
              value={directoryName}
              type="text"
            />
            {isDirectoryNameEmpty && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  marginBottom: "3px",
                }}
              >
                <Typography
                  align="left"
                  variant="caption"
                  style={{ color: "red" }}
                >
                  Please enter directory name.
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ paddingLeft: "4px" }}>Image</Typography>
            <TextfieldDefaultNew
              id="sign-password-input"
              name="sign-password-input"
              onChange={(e: any) => {
                setUrl(e.target.value);
              }}
              value={url}
              type="text"
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: "4px" }}>
            <Typography style={{ paddingLeft: "4px" }}>Color</Typography>
            <ColorSelection
              title={"Color"}
              colorCode={color}
              setColor={(colorVal: any) => setColor(colorVal.hex)}
              setInitialData={() => setColor(selectedWrapper?.colour)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ marginBottom: "8px" }}>
        <ButtonCommon
          variant="contained"
          style={{ fontSize: 11, width: "100px", marginRight: 8 }}
          color="yellow"
          onClick={handleCloseDirectoryEditModal}
        >
          Cancel
        </ButtonCommon>
        <ButtonCommon
          variant="contained"
          style={{
            fontSize: 11,
            marginLeft: 4,
            width: "100px",
          }}
          isLoadingPage={isLoadingButton}
          disabled={handleDisable()}
          color={"orange"}
          onClick={handleDirectoryEditInfo}
        >
          {"Save"}
        </ButtonCommon>
      </DialogActions>
    </DialogCommonDefault>
  );
};

export default DirectoryEditModal;
